// EquipmentTable.js
import { useQuery } from '@apollo/client';
import React, { useState } from 'react';
import './EquipmenteTable.css';
import { listUsers } from '../../../src/graphql/queries';
import { capitalize } from '../../../src/components/common/capitalize';



const EquipmentTable = ({ title, data, totalPurchase, itemCount, selectedDateType, onRowSelection, UpdateItem, selectedRows = [], // Valor por defecto para evitar undefined
  totalSelectedPrice }) => {

  // Mapeo de los campos de fecha a sus etiquetas legibles
  const dateTypeLabels = {
    purchase_date: 'Purchase Date',
    warranty_date: 'Warranty Date',
    returnable_date: 'Returnable Date',
    assignment_date: 'Assignment Date',
    // Añade más tipos si es necesario
  };

  // Si selectedDateType no tiene un valor, muestra un texto por defecto
  const dateLabel = dateTypeLabels[selectedDateType] || ' No Date';
  const [selectedItem, setSelectedItem] = useState(null);
  const { data: userData } = useQuery(listUsers);
  const [showEquimentAddOverlay, setShowEquimentAddOverlay] = useState(false);
  const [priceError, setPriceError] = useState('');

  // Formato de Fecha
  const formatDate = (dateString) => {
    const options = { month: 'long', day: 'numeric', year: 'numeric' };
    const date = new Date(dateString);
    const localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

    return localDate.toLocaleDateString(undefined, options);
  };


  const findUserFullNameByID = (userID) => {
    if (!userID) return null;

    const userIDString = userID.toString().trim();

    if (!Array.isArray(userData?.listUserFixes?.items)) return null;
    const user = userData?.listUserFixes?.items.find((u) => u.id === userIDString);
    return user ? `${capitalize(user.first_name)} ${capitalize(user.last_name)}` : null;
  };

  if (!data || data.length === 0) return null; // No mostrar tabla si no hay datos


  const handleInputChange = (field, value) => {
    setSelectedItem((prev) => {
      if (field === "tagId" || field === "tagid") {
        const keyToUpdate = prev.hasOwnProperty("tagId") ? "tagId" : "tagid";
        return {
          ...prev,
          [keyToUpdate]: value,
        };
      }
      return {
        ...prev,
        [field]: value,
      };
    });
  };

  const handleRowClick = (item, event) => {
    if (event.target.type === "checkbox") {
      return;
    }
    setSelectedItem(item);
    setShowEquimentAddOverlay(true);
  };
  

  const handleUpdateItem = () => {
    try {

      if (!selectedItem) {
        console.error("❌ Error: selectedItem o su ID es nulo o indefinido.");
        return;
      }

      const formattedData_purchase = selectedItem.purchase_date ? new Date(selectedItem.purchase_date).toISOString().split('T')[0] : null;
      //Check Price
      let priceValue = null;
      if (selectedItem.price !== "" && selectedItem.price !== null && selectedItem.price != undefined) {
        priceValue = parseFloat(selectedItem.price);

        if (isNaN(priceValue)) {
          setPriceError('Price must be a valid number.');
          return;
        }
      }
      setPriceError('');

      const normalizedTagId = (selectedItem?.__typename === "MouseFix" || selectedItem?.__typename === "Projector" || selectedItem?.__typename === "SuppliesFix" || selectedItem.__typename === "DeleteEquipmentHistoryFix")
        ? selectedItem.tagId?.trim() || ""  // Usa "tagId" solo para MouseFix...
        : selectedItem.tagid?.trim() || ""; // Usa "tagid" para el resto de los ítems

      const tagKey = selectedItem?.__typename === "MouseFix" || selectedItem?.__typename === "Projector" || selectedItem?.__typename === "SuppliesFix" || selectedItem.__typename === "DeleteEquipmentHistoryFix" ? "tagId" : "tagid";

      // ✅ Construcción del objeto de actualización dinámico
      const updateData = {
        id: selectedItem.id,
        price: priceValue,
        store: selectedItem.store,
        purchase_date: formattedData_purchase,
      };

      // ✅ Solo agregar estos campos si el ítem **NO** es "Projector"
      if (selectedItem.__typename !== "Projector") {
        updateData.assigned_to = "";
        updateData.userId = selectedItem.userId || "";
      }
      // ✅ Solo agregar estos campos si el ítem **NO** es "Bag"
      if (selectedItem.__typename !== "BagFix") {
        updateData[tagKey] = normalizedTagId;

      }
      // ✅ Solo agregar estos campos si el ítem **NO** es "ClickCounter"
      if (selectedItem.__typename !== "ClickCounterFix") {
        updateData.serial_Number = selectedItem.serial_Number || "";
      }

      // ✅ Solo agregar "team" si el ítem **NO** es "Projector" y **NO** es "ClickCounter"
      if (selectedItem.__typename !== "Projector" && selectedItem.__typename !== "ClickCounterFix") {
        updateData.team = selectedItem.team || "";
      }
      // ✅ Solo agregar "serial Number" si el ítem **NO** es "BagFix" y **NO** es "ClickCounter"
      if (selectedItem.__typename !== "BagFix" && selectedItem.__typename !== "ClickCounterFix") {
        updateData.serial_Number = selectedItem.serial_Number || "";
      }

      // ✅ Solo agregar "brand" si el ítem **NO** es "ClickCounterFix" y **NO** es "SuppliesFix"
      if (selectedItem.__typename !== "ClickCounterFix" && selectedItem.__typename !== "SuppliesFix") {
        updateData.brand = selectedItem.brand || "";
      }
      console.log("Datos", updateData)

      // ✅ Envío de actualización
      UpdateItem({ variables: { input: updateData } })
        .then(() => {
          setShowEquimentAddOverlay(false);
          setPriceError('');
        })
        .catch(error => {
          console.error("❌ Error updating item:", error);
        });

    } catch (err) {
      console.error("❌ Unexpected error in handleUpdateItem:", err);
    }
  };

  return (

    <div className="equipment-table">

      <h2 style={{ marginBottom: "5px" }}>{title}</h2>
      {selectedDateType === "purchase_date" && (
        <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "10px" }}>
          {`${title} Purchase Total: $${totalPurchase}`}
        </div>

      )}


      <table>
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    const allIds = data.map((item) => item.id);
                    allIds.forEach((id) => onRowSelection(id));
                  } else {
                    data.map((item) => onRowSelection(item.id));
                  }
                }}
                checked={data.length > 0 && data.every((item) => selectedRows.includes(item.id))}
              />
            </th>
            <th>Item</th>
            <th >TAG</th>
            <th >Brand</th>
            <th >Price</th>
            <th >Store</th>
            <th >Serial Number</th>
            <th >Assigned to</th>
            <th>Team && Year</th>
            <th>{dateLabel}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => {

            return (

              <tr key={item.id} onClick={(event) => handleRowClick(item, event)} style={{ cursor: "pointer" }}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(item.id)}
                    onChange={(e) => {
                      e.stopPropagation(); 
                      onRowSelection(item.id);
                    }}
                  />
                </td>
                <td>{title}</td>
                <td>{item.tagId || item.tagid}</td>
                <td>{item.brand || item.name}</td>
                <td>{item.price}</td>
                <td>{item.store}</td>
                <td>{item.serial_Number}</td>
                <td>{item.userId ? findUserFullNameByID(item.userId) : "N/A"}
                </td>
                <td>{item.team}</td>
                <td>{formatDate(item[selectedDateType])}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="10" style={{ fontWeight: "bold", textAlign: "center" }}>
              {`Total ${title}: ${itemCount}`}
            </td>
            <td colSpan="10" style={{ fontWeight: 'bold', textAlign: 'center', display: 'none' }}>
              {`Total Selected Price: $${totalSelectedPrice}`}
            </td>
          </tr>

        </tfoot>
      </table>
      {showEquimentAddOverlay && (

        <div className="equipment_add_overlay" onClick={(e) => {

          if (e.target.classList.contains("equipment_add_overlay")) {
            setShowEquimentAddOverlay(false);
            setSelectedItem(null);
          }
        }}>
          <div className="overlay-content-inventory ">
            <div className="header-row">
              <h2 className="header-title">Edit {title === "Supplies" ? title : title.replace(/s$/, '')}</h2>
              <button onClick={() => {
                setShowEquimentAddOverlay(false);
                setSelectedItem(null);
              }}>X</button>
            </div>
            {((selectedItem?.tagid !== undefined && selectedItem.tagid !== " ") ||
              (selectedItem?.tagId !== undefined && selectedItem.tagId !== " ")) && (
                <>
                  <label>TAG:</label>
                  <input
                    name="tagId"
                    placeholder="TAG"
                    value={selectedItem.__typename === "MouseFix" || selectedItem.__typename === "Projector" || selectedItem.__typename === "SuppliesFix" || selectedItem.__typename === "DeleteEquipmentHistoryFix" ? selectedItem.tagId : selectedItem.tagid}
                    onChange={(e) => handleInputChange(selectedItem.__typename === "MouseFix" || selectedItem.__typename === "Projector" || selectedItem.__typename === "DeleteEquipmentHistoryFix" || selectedItem.__typename === "SuppliesFix" ? "tagId" : "tagid", e.target.value)}
                    required
                  />
                </>
              )}

            {selectedItem?.brand !== undefined && selectedItem.brand !== " " && (
              <>
                <label>Brand:</label><input name="brand" placeholder="Brand" value={selectedItem.brand} onChange={(e) => handleInputChange("brand", e.target.value)} />
              </>
            )}
            <label>Price:</label><input name="price" placeholder="price" value={selectedItem.price} onChange={(e) => handleInputChange("price", e.target.value)} />
            <label>Store:</label><input name="store" placeholder="store" value={selectedItem.store} onChange={(e) => handleInputChange("store", e.target.value)} />
            {selectedItem?.serial_Number !== undefined && selectedItem?.serial_Number !== " " && (
              <>
                <label>Serial Number:</label>
                <input name="serial_Number" placeholder="serial_Number" value={selectedItem.serial_Number} onChange={(e) => handleInputChange("serial_Number", e.target.value)} />
              </>
            )}
            {selectedItem?.userId !== undefined && selectedItem.userId !== " " && (
              <>
                <label>Assigned To:</label>
                <select
                  name="userId"
                  value={selectedItem.userId}
                  onChange={(e) => handleInputChange("userId", e.target.value)}
                >
                  <option value="" disabled>
                    Select an employee
                  </option>
                  <option value="n/a">N/A</option>
                  {userData?.listUserFixes?.items.length > 0 ? (
                    userData?.listUserFixes?.items.map((option) => (
                      <option key={option.id} value={option.id}>
                        {capitalize(option.first_name)} {capitalize(option.last_name)}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>No employees available</option>
                  )}


                </select>
              </>
            )}
            {selectedItem?.team !== undefined && selectedItem.team !== " " && (
              <>
                <label>Team:</label><input name="team" placeholder="team" value={selectedItem.team} onChange={(e) => handleInputChange("team", e.target.value)} />
              </>)}
            <label htmlFor="purchase_date">Purchase Date:</label>
            <input
              type="Date"
              id="purchase_date"
              name="purchase_date"
              value={selectedItem.purchase_date}
              onChange={(e) => handleInputChange("purchase_date", e.target.value)}

            />
            {priceError && <p className="error">{priceError}</p>} {/* Display price error message */}
            <div className="button-group">
              <button className="overlay-add-monitor" onClick={handleUpdateItem} >
              Update {title === "Supplies" ? title : title.replace(/s$/, '')}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>


  );
};

export default EquipmentTable;
